import * as types from './types'
import jwtDecode from 'jwt-decode'

export default {
  [types.SET_USER] (state) {
    try {
      let token = localStorage.token
      if (token) {
        let _user = JSON.parse(jwtDecode(token).user)
        state.loggedUser = {
          token,
          email: _user.email,
          role: _user.roles[0].name,
          permissions: _user.permissions,
          location: _user.location,
          locationLogo: typeof localStorage.locationLogo === 'undefined' ? null : localStorage.locationLogo
        }
      } else {
        state.loggedUser = { token: null, email: null, role: null }
      }
    } catch (e) {
      throw e
    }
  },
  [types.LOGOUT] (state) {
    localStorage.clear()
    state.loggedUser = { token: null, email: null, role: null }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/mutations.js